




































import { PropType, defineComponent, getCurrentInstance } from '@vue/composition-api';
import { Message, IntentionData, IntentType } from '../../dataType';
import { useLocale } from '../../hooks/useLocale';
import Card from './Card.vue';
import { useMessage } from '../../hooks/useMessage';
import { useIntention } from '../../hooks/useIntention';
import { useMessageInteract } from '../../hooks/useMessageInteract';

export default defineComponent({
  components: {
    Card
  },
  props: {
    message: {
      type: Object as PropType<Message<IntentionData>>,
      required: true
    }
  },
  setup(props) {
    const { addUserTextMessage, robotWaitWithAsyncOperation, sendMessageAndUpdateId } = useMessage();
    const instance = getCurrentInstance()?.proxy!;
    const { t } = useLocale();
    const { isDisabled } = useMessageInteract(props.message);
    const { intentionTab } = useIntention();
    const clickSendMessage = async (val: {label:string, value:IntentType}, event: Event) => {
      // 发送用户消息
      const msg = addUserTextMessage(val.label);
      const example = props.message.content.examples.find(item => item.intent === val.value) || [];
      const params = {
        inputText: {
          text: val.label,
          push: true,
          save: true
        },
        actionType: 'example_push',
        actionJson: {
          header:t('saas.rootChat.intentionBackQuestion.mainText'),
          example: example
        }
      };
      robotWaitWithAsyncOperation(() => sendMessageAndUpdateId(msg, 'confirm', params, {
        event: event,
        intent: val.value,
        parabolaAnimation: true
      }));
      instance.$track.send('WebIM_SendIntent', {
        Send_Type: '选择意图机器人',
        Intent_Type: val.value,
        Intent_Keywords:  val.label
      }, true);
    };

    return {
      buttonItem: intentionTab,
      isDisabled,
      clickSendMessage
    };
  }
});
